// Actions (must be name-spaced for reducer)
export const SET_COUNTRY = "SET_COUNTRY";

// Reducer
export function countryReducer(country = "", action = {}) {
    switch (action.type) {
        case SET_COUNTRY:
            return action.country;
        default:
            return country;
    }
}

// Action Creators
export function setCountry(country = "") {
    return {
        type: SET_COUNTRY,
        country
    };
}

export default {
    countryReducer,
    setCountry
};
